//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Formboard.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[],[[["newType"],"ChangeType",{},1,0],[["newSegment"],"NewSegment",{},1,0],[["newDir"],"UpdateLineAngleVec",{},1,0],[["anchorSeg","anchorRcp","angle"],"GetLineData",{},0,0],[["firstPivot","firstBendMethod","firstBendValue","secondPivot","secondBendMethod","secondBendValue"],"CreateNewRadialBend",{},6,0],[["pivotLocation","bendMethod","bendValue"],"AddRadialPivot",{},3,0],[["pivotIndex"],"RemoveRadialPivot",{},1,0],[["pivotIndex","newLocation","newBendMethod","newBendValue"],"UpdateRadialPivot",{},4,0],[["anchorLocation","firstPoint","secondPoint"],"CreateNewSpline",{},3,0],[["pointIndex"],"RemoveSplinePoint",{},1,0],[["pointLocation"],"AddSplinePoint",{R_:{pointIndex:''}},1,0],[["pointIndex","pointLocation","inDrag"],"UpdateSplinePoint",{},3,0],[[],"CommitCurrentOperation",{},0,0],[[],"SwapAnchorEnd",{},0,0],[["view"],"SetActiveView",{},1,0]],[]];
SPLM.Formboard.ShapeSegmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Formboard.ShapeSegmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;